"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e = require("react"),
    t = require("@react-pdf-viewer/core");

function o(e) {
  if (e && e.__esModule) return e;
  var t = Object.create(null);
  return e && Object.keys(e).forEach(function (o) {
    if ("default" !== o) {
      var n = Object.getOwnPropertyDescriptor(e, o);
      Object.defineProperty(t, o, n.get ? n : {
        enumerable: !0,
        get: function get() {
          return e[o];
        }
      });
    }
  }), t.default = e, Object.freeze(t);
}

var n = o(e),
    r = function r(e) {
  var t = e.bookmark,
      o = e.depth,
      r = e.doc,
      c = e.onClick,
      i = e.onJumpToDest,
      u = n.createRef(),
      s = n.createRef(),
      l = n.useRef(!0),
      m = t.items && t.items.length > 0;
  return n.createElement(n.Fragment, null, n.createElement("div", {
    className: "rpv-bookmark-item",
    style: {
      paddingLeft: 20 * o + 4 + "px"
    },
    onClick: function onClick() {
      !m && t.dest && c(t.dest);
    }
  }, m && n.createElement("span", {
    ref: u,
    className: "rpv-bookmark-toggle",
    onClick: function onClick() {
      l.current = !l.current;
      var e = s.current,
          t = u.current;
      e && t && (e.style.display = l.current ? "block" : "none", t.classList.toggle("rpv-bookmark-toggle-expanded"));
    }
  }, "►"), t.url ? n.createElement("a", {
    className: "rpv-bookmark-title",
    href: t.url,
    rel: "noopener noreferrer nofollow",
    target: t.newWindow ? "_blank" : ""
  }, t.title) : n.createElement("div", {
    className: "rpv-bookmark-title",
    onClick: function onClick() {
      m && t.dest && c(t.dest);
    }
  }, t.title)), m && n.createElement("div", {
    ref: s
  }, n.createElement(a, {
    bookmarks: t.items,
    depth: o + 1,
    doc: r,
    onJumpToDest: i
  })));
},
    a = function a(e) {
  var o = e.bookmarks,
      a = e.depth,
      c = void 0 === a ? 0 : a,
      i = e.doc,
      u = e.onJumpToDest,
      s = function s(e) {
    t.getDestination(i, e).then(function (e) {
      var t = e.pageIndex,
          o = e.bottomOffset,
          n = e.scaleTo;
      u(t + 1, o, n);
    });
  };

  return n.createElement("ul", {
    className: "rpv-bookmark-list"
  }, o.map(function (e, t) {
    return n.createElement("li", {
      key: t
    }, n.createElement(r, {
      bookmark: e,
      depth: c,
      doc: i,
      onClick: s,
      onJumpToDest: u
    }));
  }));
},
    c = function c(e) {
  var o = e.doc,
      r = e.onJumpToDest,
      c = n.useContext(t.LocalizationContext),
      i = n.useState({
    isLoaded: !1,
    items: []
  }),
      u = i[0],
      s = i[1];
  return n.useEffect(function () {
    s({
      isLoaded: !1,
      items: []
    }), o.getOutline().then(function (e) {
      s({
        isLoaded: !0,
        items: e || []
      });
    });
  }, [o]), u.isLoaded ? 0 === u.items.length ? n.createElement("div", {
    className: "rpv-bookmark-empty"
  }, c && c.bookmark ? c.bookmark.noBookmark : "There is no bookmark") : n.createElement("div", {
    className: "rpv-bookmark-container"
  }, n.createElement(a, {
    bookmarks: u.items,
    depth: 0,
    doc: o,
    onJumpToDest: r
  })) : n.createElement(t.Spinner, null);
},
    i = function i(e) {
  var o = e.store,
      r = n.useState(o.get("doc")),
      a = r[0],
      i = r[1],
      u = function u(e) {
    i(e);
  };

  return n.useEffect(function () {
    return o.subscribe("doc", u), function () {
      o.unsubscribe("doc", u);
    };
  }, []), a ? n.createElement(c, {
    doc: a,
    onJumpToDest: function onJumpToDest(e, t, n) {
      var r = o.get("jumpToDestination");
      r && r(e, t, 0, n);
    }
  }) : n.createElement("div", {
    className: "rpv-bookmark-list-loader"
  }, n.createElement(t.Spinner, null));
};

exports.bookmarkPlugin = function () {
  var e = n.useMemo(function () {
    return t.createStore({});
  }, []);
  return {
    install: function install(t) {
      e.update("jumpToDestination", t.jumpToDestination);
    },
    onDocumentLoad: function onDocumentLoad(t) {
      e.update("doc", t.doc);
    },
    Bookmarks: function Bookmarks() {
      return n.createElement(i, {
        store: e
      });
    }
  };
};